import axios from "axios";

const getToken = () => {
  return localStorage.getItem("token");
};

const getInstance = () => {
  return localStorage.getItem("instance");
};

const api = axios.create({
  baseURL: import.meta.env.VITE_BACK_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    const instance = getInstance();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (instance) {
      config.headers.Instance = instance;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;
    if (
      response?.status === 401 &&
      config?.url !== "/auth/signin" &&
      config?.url !== "/auth/2fa" // skip login endpoints
    ) {
      localStorage.removeItem("token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  },
);

export default api;
